import actions from './actions';

const initState = { locations: null };

export default function logReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOCATION_FIELDS_SUCCESS:
      return {
        ...state,
        fields: action.fields,
      };
    case actions.LOCATION_SUCCESS:
      return { ...state, locations: action.locations };
    case actions.LOCATION_CREATE_SUCCESS:
      return { ...state, locationCreateSuccess: action.locationCreateSuccess };
    case actions.LOCATION_UPDATE_SUCCESS:
      return { ...state, locationUpdateSuccess: action.locationUpdateSuccess };
    case actions.LOCATION_DELETE_SUCCESS:
      return { ...state, locationDeleteSuccess: action.locationDeleteSuccess };
    case actions.LOCATION_ERROR:
      return { ...state, locationError: action.locationError };
    default:
      return state;
  }
}
